import { render, staticRenderFns } from "./CountryDetails.vue?vue&type=template&id=57aaca44&scoped=true&"
import script from "./CountryDetails.vue?vue&type=script&lang=js&"
export * from "./CountryDetails.vue?vue&type=script&lang=js&"
import style0 from "./CountryDetails.vue?vue&type=style&index=0&id=57aaca44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aaca44",
  null
  
)

export default component.exports